import type {UserPreference} from 'typings/portaro.be.types';
import type {UserPreferencesService} from '../../features/user/user-preferences/user-preferences.service';

export class KpUserPreferencesModalService {
    public static serviceName = 'kpUserPreferencesModalService';

    /*@ngInject*/
    constructor(private userPreferencesService: UserPreferencesService) {
    }

    public async savePreference(preference: UserPreference): Promise<UserPreference> {
        return this.userPreferencesService.save(preference);
    }

    public async setPreferenceToDefault(preference: UserPreference): Promise<UserPreference> {
        return this.userPreferencesService.setToDefault(preference);
    }
}